// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ws-input[data-v-0ee69df1]{border:1px solid var(--dark-grey);border-radius:5px;padding:.5rem .75rem;height:2em}", ""]);
// Exports
module.exports = exports;
